<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';

import {
  AGENT_BOT_PIPELINE_ACTIONS,
  pipelineActionTranslationKey,
  sanitizeAgentBotPipelineActions,
} from '../helpers/agentBotPermissions';

const { t } = useI18n();

const modelValue = defineModel({ type: Array, default: () => [] });

const acoes = AGENT_BOT_PIPELINE_ACTIONS;

const selecionadas = computed(() =>
  sanitizeAgentBotPipelineActions(modelValue.value)
);

const estaLigada = acao => selecionadas.value.includes(acao);

// Lista vazia significa "todas" — é o padrão e preserva o comportamento de quem
// nunca configurou. O aviso existe para isso não parecer "nenhuma".
const estaVazia = computed(() => selecionadas.value.length === 0);

const alternar = acao => {
  const atual = new Set(selecionadas.value);
  if (atual.has(acao)) atual.delete(acao);
  else atual.add(acao);
  modelValue.value = sanitizeAgentBotPipelineActions([...atual]);
};

const limpar = () => {
  modelValue.value = [];
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-center justify-between gap-2">
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('AGENT_BOTS.FORM.PIPELINE_ACTIONS.TITLE') }}
      </span>
      <button
        v-if="!estaVazia"
        type="button"
        class="text-xs text-n-slate-11 underline"
        @click="limpar"
      >
        {{ t('AGENT_BOTS.FORM.PIPELINE_ACTIONS.ALLOW_ALL') }}
      </button>
    </div>

    <p class="mt-0 mb-1 text-xs text-n-slate-11">
      {{
        estaVazia
          ? t('AGENT_BOTS.FORM.PIPELINE_ACTIONS.EMPTY_MEANS_ALL')
          : t('AGENT_BOTS.FORM.PIPELINE_ACTIONS.HELP')
      }}
    </p>

    <div class="flex flex-col gap-1">
      <label
        v-for="acao in acoes"
        :key="acao"
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-n-alpha-1"
        :data-testid="`pipeline-action-${acao}`"
      >
        <Checkbox
          class="flex-shrink-0"
          :model-value="estaLigada(acao)"
          @update:model-value="alternar(acao)"
        />
        <span class="text-sm text-n-slate-12">
          {{ t(pipelineActionTranslationKey(acao)) }}
        </span>
      </label>
    </div>
  </div>
</template>
